import React from 'react';
import Logo from './Logo';
import Nav from './Nav';

const Ojo = () => {
    return (
        <nav className="row img-background-head">
            <div>
                <Logo />
                <Nav />
            </div>
        </nav>
    );
};
export default Ojo;
